/// <amd-module name="TFS/Admin/Views/SettingsSearch/Sources/SettingsSearchSource" />

import { ISearchRestClient, getSearchClient } from "TFS/Admin/Common/RestClient/Search";
import { IVssRestClientOptions, TeamFoundationHostType } from "VSS/Platform/Context";
import { ProjectState, WebApiTeam } from "Tfs/Platform/Contracts/Core";
import { SearchScope, SettingResult, SettingSearchRequest, SettingSearchResponse } from "TFS/Admin/Common/Contracts/Search.Shared";

import { IVssPageContext } from "VSS/Platform/Context";
import { TeamProjectReference } from "Tfs/Platform/Contracts/Core";
import { getCoreClient } from "Tfs/Platform/RestClient/Core";

import AdminResources = require("TFS/Admin/Views/SettingsSearch/Resources");

export class SettingsSearchSource {
    private pageContext: IVssPageContext;
    public constructor(context: IVssPageContext) {
        this.pageContext = context;
    }

    public getSettingSearchResults(keyword: string): Promise<SettingSearchResponse> {
        const client = getSearchClient(this.pageContext, { hostType: TeamFoundationHostType.ProjectCollection });
        const searchQuery: SettingSearchRequest = {
            searchText: keyword,
            $top: 100,
            $skip: 0,
            $orderBy: [],
            filters: {},
            includeFacets: false
        };
        return client.fetchSettingSearchResults(searchQuery);
    }

    public getProjects(stateFilter?: ProjectState): Promise<TeamProjectReference[]> {
        const client = getCoreClient(this.pageContext);
        if (stateFilter == undefined) {
            stateFilter = ProjectState.WellFormed;
        }
        return client.getProjects(stateFilter);
    }

    public getTeamsForProject(projectId: string): Promise<WebApiTeam[]> {
        const client = getCoreClient(this.pageContext);
        return client.getTeams(projectId);
    }

    public getSetTitle(searchScope: SearchScope): string {
        switch (searchScope) {
            case SearchScope.None:
                return AdminResources.NoneScopeTitle;
            case SearchScope.Organization:
                return AdminResources.OrganizationScopeTitle;
            case SearchScope.Project:
                return AdminResources.ProjectScopeTitle;
            case SearchScope.User:
                return AdminResources.UserScopeTitle;
            default:
                return AdminResources.DefaultScopeTitle;
        }
    }
}
